import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${(props) => props.theme.antd.colorWhite};
  border-radius: 4px;
  padding: 16px;
`;

export const Block = styled.div`
  padding: 25px;
  background-color: ${(props) => props.color || props.theme.antd.colorPrimary};
  border-radius: 4px;
`;
